import { IHttpClient } from '@/core/services/http'
import { Category } from '../model/category.model'

export function createGetChildCategoriesUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function (parentId: number): Promise<Category[]> {
    try {
      const res = await httpClient.version('v1').get<{
        data: Category[]
      }>(`/website/buyer/categories?parent_id=${parentId}`)
      return res.data.data
    } catch {
      return []
    }
  }
}
